<template>
  <div class="wrapper contact-page">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/jgestates-contact-us-1.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h1 class="title">Contact Us</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="contact-content">
        <div class="container">
          <div class="row">
            <div class="col-md-7 ml-auto mr-auto">
              <contact-form></contact-form>
            </div>
            <div class="col-md-5 ml-auto mr-auto">
              <info-section
                type="primary"
                class="mt-5"
                icon="now-ui-icons location_pin"
              >
                <h4 class="info-title">Find us at the office</h4>
                <p>
                  217 Evington Lane, <br />
                  Evington Village, <br />
                  Leicester, <br/>
                  LE5 6DJ
                </p>
              </info-section>

              <info-section type="primary" icon="now-ui-icons tech_mobile">
                <h4 class="info-title">Give us a ring</h4>
                <p>
                  07760 777748 <br />
                  Mon - Fri 8:30 - 17:30
                </p>
              </info-section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <gmap-map
      id="map"
      class="big-map"
      :center="center"
      :zoom="13"
      map-type-id="terrain"
    >
      <gmap-marker :position="center"> </gmap-marker>
    </gmap-map>
  </div>
</template>
<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/emailjs-com@3/dist/email.min.js"></script>
<script>
import { InfoSection } from "@/components";
import ContactForm from "../components/Customised/ContactForm.vue"
import { API_KEY } from "@/constants";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY,
  },
});
export default {
  name: "contact-us",
  components: {
    InfoSection,
    ContactForm
  },
  data() {
    return {
      emailjs: {
        serviceId: 'service_ip7hfdq',
        templateId: 'template_z27fwhe',
        userId: 'user_Z4lDmCXRAJmGURD0o3VxY'
      },
      form: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
      center: {
        lat: 52.620475,
        lng: -1.080284,
      },
    };
  },
  methods: {
    sendmail (e) {
      const templateParams = {
        name: this.form.name,
        email: this.form.email,
        phone: this.form.phone,
        message: this.form.message
    };

    emailjs.send(this.emailjs.serviceId, this.emailjs.templateId, templateParams, this.emailjs.userId)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
      }, (err) => {
        console.log('FAILED...', err);
      });

      this.form.name = ''
      this.form.email = ''
      this.form.phone = ''
      this.form.message = ''
    },
  }
};
</script>
<style>
</style>
